import {
  useLogoutFunction,
  useOrgHelper,
} from "@propelauth/react";
import { Check, ChevronDown, LogOut, Settings, UserPlus } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu";
import { cn } from "../../../lib/utils";
import UserButton from "./UserButton";

const WORKSPACE_COLORS = [
  "bg-primary",
  "bg-blue-500",
  "bg-green-500",
  "bg-orange-500",
  "bg-violet-500",
  "bg-cyan-500",
  "bg-rose-500",
  "bg-amber-500",
];

const getWorkspaceColor = (index: number) =>
  WORKSPACE_COLORS[index % WORKSPACE_COLORS.length];

const AvatarMenu = ({
  name,
  desc,
  img,
  menu,
}: any) => {
  const logout = useLogoutFunction();
  const params = useParams();
  const orgHelper: any = useOrgHelper();
  const navigate = useNavigate();
  const workspaces = orgHelper?.orgHelper.getOrgs();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="w-full">
          <UserButton
            minimized={!menu}
            icon={<ChevronDown className="w-3.5 h-3.5 ml-3 text-muted-foreground" />}
            name={name}
            email={desc}
            image={img}
          />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[260px] z-50">
        <div className="px-2 py-1.5">
          <span className="text-xs font-medium text-muted-foreground">Workspaces</span>
        </div>
        {workspaces?.map((workspace: any, index: number) => {
          const isActive = params?.workspaceId === workspace?.orgMetadata?.unique_identifier;
          const initial = (workspace?.orgName || "W").charAt(0).toUpperCase();
          const colorClass = getWorkspaceColor(index);

          return (
            <DropdownMenuItem
              key={workspace?.orgId}
              onClick={() => {
                localStorage.setItem("he_defws", workspace?.orgId);
                navigate("/", { state: { refresh: true } });
              }}
              className={cn(
                "flex items-center gap-2.5 px-2 py-2 cursor-pointer",
                isActive && "bg-primary/5"
              )}
            >
              <div className={cn(
                "w-6 h-6 rounded-md flex items-center justify-center text-xs font-semibold text-white",
                colorClass
              )}>
                {initial}
              </div>
              <span className="flex-1 text-sm truncate">{workspace?.orgName}</span>
              {isActive && (
                <Check className="h-4 w-4 text-primary" />
              )}
            </DropdownMenuItem>
          );
        })}

        <DropdownMenuSeparator />

        <DropdownMenuItem
          onClick={() => {
            navigate(`/home/${params.workspaceId}/settings/workspace`);
          }}
          className="flex items-center gap-2 px-2 py-2 cursor-pointer"
        >
          <Settings className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">Settings</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={() => {
            navigate(`/home/${params.workspaceId}/settings/members`);
          }}
          className="flex items-center gap-2 px-2 py-2 cursor-pointer"
        >
          <UserPlus className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">Invite team members</span>
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem
          onClick={() => {
            logout(true);
          }}
          className="flex items-center gap-2 px-2 py-2 cursor-pointer text-destructive"
        >
          <LogOut className="h-4 w-4" />
          <span className="text-sm">Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AvatarMenu;
